/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { map } from 'lodash';
import { PopoverListBtn } from '@blend/enterprise-components';
import { StyleSheet, css } from 'aphrodite';
import { DropdownEllipsisBtn } from '@blend/enterprise-components';
import { inputFormatters } from '@blend/shared-react';
import { FeeFormValue } from '../types';
import { Pricing } from 'blb-types/pricing';

export interface LedgerRowActionConfig {
  clickHandler?: (rowIdx: number) => void;
  columnWidth: number;
  dropdownActions?: {
    clickHandler: (rowIdx: number) => void;
    icon?: PopoverListBtn.Props['icon'];
    label: string;
  }[];
  type: 'EllipsisDropdown';
}

const styles = StyleSheet.create({
  dropdownWrapper: {
    marginLeft: 10,
  },
});

export const generateRowActionComponents = (
  rowActionsConfig: LedgerRowActionConfig[],
  rowIdx: number,
  disableRowActions: boolean,
) => {
  return map(rowActionsConfig, rowAction => {
    if (rowAction.type === 'EllipsisDropdown') {
      const actions = map(rowAction.dropdownActions, ({ label, clickHandler, icon }) => ({
        icon,
        label,
        onClick: () => clickHandler(rowIdx),
      }));
      return (
        <div className={css(styles.dropdownWrapper)}>
          <DropdownEllipsisBtn
            actions={actions}
            anchorPosition="bottom-end"
            disabled={disableRowActions}
            key={`EllipsisDropdown-row-${rowIdx}`}
            listBtnSize="md"
          />
        </div>
      );
    }
  });
};

export const getPercentagesFromWidths = (columnWidths: number[], totalWidth: number): string[] => {
  const percents = map(columnWidths, width => {
    return `${(width / totalWidth) * 100}%`;
  });
  return percents;
};

const getCopyForCurrentStatus = (feeWithMoreInfoRequested: FeeFormValue) => {
  switch (feeWithMoreInfoRequested.updateType) {
    case Pricing.UpdateType.DELETE:
      return 'N/A';
    default:
      return inputFormatters.MONEY_CENTS.formatWithDollarSignAndCents(feeWithMoreInfoRequested.amount);
  }
};

export const getMoreInfoRequestCopy = (fee: FeeFormValue) =>
  `
  ${
    fee.previousApprovedFee
      ? inputFormatters.MONEY_CENTS.formatWithDollarSignAndCents(fee.previousApprovedFee.amount)
      : 'N/A'
  }
  → ${getCopyForCurrentStatus(fee)}
`;
